/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from '@emotion/react';
import useStyle from './AffirmPageBanner.style';
import { AffirmLogo } from '@shared/react-ui-core';
import { Modal } from '@shared/cove-ui';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { AffirmModalContent } from '../AffirmInfoModal/AffirmModelContent';

const AffirmPageBanner: React.FC<{ wrapperCss?: SerializedStyles }> = ({
  ...props
}) => {
  const [showAffirmModal, setShowAffirmModal] = useState(false);
  const styles = useStyle();
  const { t } = useTranslation();
  return (
    <div
      css={css`
        ${styles.base};
        ${props.wrapperCss};
      `}
    >
      <div className="container">
        <div>
          <div className="mobile-only">
            <h2 style={{ justifyContent: 'center' }}>
              <div className="header-flex">
                <span style={{ paddingRight: '4px', paddingTop: '2px' }}>
                  {t('affirm.AffirmPageBanner.buy-now', {
                    ns: 'components',
                    defaultValue: 'Buy now',
                  })}
                  ,
                </span>
                <span style={{ paddingTop: '2px' }}>
                  {t('affirm.AffirmPageBanner.pay-later', {
                    ns: 'components',
                    defaultValue: 'pay later with',
                  })}
                </span>
                <div className="affirm-logo">
                  <AffirmLogo variant={'original'} width={60} />
                </div>
              </div>
            </h2>
          </div>
          <div className="desktop-only">
            <h2>
              {t('affirm.AffirmPageBanner.buy-now', {
                ns: 'components',
                defaultValue: 'Buy now',
              })}
              ,{' '}
              {t('affirm.AffirmPageBanner.pay-later', {
                ns: 'components',
                defaultValue: 'pay later with',
              })}
              <div className="affirm-logo">
                <AffirmLogo variant={'original'} width={100} />
              </div>
            </h2>
          </div>
          <p className="affirm-copy">
            {t('affirm.AffirmPageBanner.choose-affirm', {
              ns: 'components',
              defaultValue:
                "Choose Affirm at checkout to pay a monthly installment that fits your budget. It's simple and there are no late fees or surprises.",
            })}
            <Modal open={showAffirmModal} onOpenChange={setShowAffirmModal}>
              <Modal.Trigger>
                <span className="ml-cove-10 cursor-pointer font-medium text-cove-navy-blue underline underline-offset-2">
                  {t('learn-more', {
                    ns: 'common',
                    defaultValue: 'Learn more',
                  })}
                </span>
              </Modal.Trigger>
              <AffirmModalContent />
            </Modal>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AffirmPageBanner;
